import ApiService from "@/core/services/api.service";

//Actions
export const FETCH_AI_INVOICE_ACCOUNTING_VALUE_TYPES =
  "fetchAiInvoiceAccountingValueTypes";
export const FETCH_AI_INVOICE_ACCOUNTING_VALUE_TYPE =
  "fetchAiInvoiceAccountingValueType";
export const SAVE_AI_INVOICE_ACCOUNTING_VALUE_TYPE =
  "saveAiInvoiceAccountingValueType";
export const UPDATE_AI_INVOICE_ACCOUNTING_VALUE_TYPE =
  "updateAiInvoiceAccountingValueType";
export const DELETE_AI_INVOICE_ACCOUNTING_VALUE_TYPE =
  "deleteAiInvoiceAccountingValueType";
export const FETCH_AI_INVOICE_TYPE_ACCOUNTING_VALUE_TYPES =
  "fetchAiInvoiceTypeAccountingValueTypes";

//Mutations
export const SET_ERROR = "setError";
export const SET_LOADING = "setLoadingAiInvoiceAccountingValueType";
export const SET_AI_INVOICE_ACCOUNTING_VALUE_TYPES =
  "setAiInvoiceAccountingValueTypes";

const state = {
  ai_invoice_accounting_value_types_errors: [],
  ai_invoice_accounting_value_types: [],
  isLoadingAiInvoiceAccountingValueType: false
};

const getters = {
  isLoadingAiInvoiceAccountingValueType() {
    return state.isLoadingAiInvoiceAccountingValueType;
  },
  getAiInvoiceAccountingValueTypes() {
    return state.ai_invoice_accounting_value_types;
  }
};

const actions = {
  [FETCH_AI_INVOICE_ACCOUNTING_VALUE_TYPES](context, apiParams = "") {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("ai-invoice-accounting-value-types" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [FETCH_AI_INVOICE_ACCOUNTING_VALUE_TYPE](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("ai-invoice-accounting-value-types", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [SAVE_AI_INVOICE_ACCOUNTING_VALUE_TYPE](context, payload) {
    context.commit(SET_LOADING, true);
    const form = payload;
    return new Promise((resolve, reject) => {
      ApiService.post("ai-invoice-accounting-value-types", form)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [UPDATE_AI_INVOICE_ACCOUNTING_VALUE_TYPE](context, params) {
    context.commit(SET_LOADING, true);
    const form = params.payload;
    const id = params.id;
    return new Promise((resolve, reject) => {
      ApiService.update("ai-invoice-accounting-value-types", id, form)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [DELETE_AI_INVOICE_ACCOUNTING_VALUE_TYPE](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.delete("ai-invoice-accounting-value-types", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [FETCH_AI_INVOICE_TYPE_ACCOUNTING_VALUE_TYPES](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get(`ai-invoice-accounting-value-types/ai-invoice-type/${id}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  }
};

const mutations = {
  [SET_ERROR](state, errors) {
    state.isLoadingAiInvoiceAccountingValueType = false;
    if (Array.isArray(errors)) {
      state.ai_invoice_accounting_value_types_errors = errors;
    } else {
      state.ai_invoice_accounting_value_types_errors = [errors];
    }
  },
  [SET_LOADING](state, value) {
    state.isLoadingAiInvoiceAccountingValueType = value;
  },
  [SET_AI_INVOICE_ACCOUNTING_VALUE_TYPES](state, data) {
    state.isLoadingAiInvoiceAccountingValueType = false;
    state.ai_invoice_accounting_value_types = data.data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
